/**
 * Função utilitária, não faz nada
 */
export const noop = () => null
